module.exports = __webpack_public_path__ + "static/media/AirbnbCerealApp-Black.9161b597.woff";